<template>
  <div id="app-container" v-if="payInfo.deposit_no">
    <div class="n1sHi1_gDox2Q8ezpdZH5">
      <div class="_3nvVZbeP_KKFGRKZ3SxfW4" style="">
        <div class="_2uM338LxSZnEUB6bCz4axi">
          <div>
            <div class="_2HCazjAzieT4L96opZihj9">剩余支付时间：</div>
            <div class="_1ar3pTm_JYB-u2qWpt6e_z">{{ m >= 10 ? m : `0${m}` }}:{{ s >= 10 ? s : `0${s}` }}</div>
          </div>
          <div class="_3ATbZ84037ZhIQDiT-2nyD"></div>
          <div class="_3CQ4hAT8Rn9-ZCUrRPjV7M">
            <div class="_9SJLkU9QpzPYzWOZY3Rqk">
              <span>订单编号：</span><span>{{ payInfo.deposit_no }}</span>
            </div>
            <div class="_9SJLkU9QpzPYzWOZY3Rqk" v-if="type == 'usdtpay'">
              <span>当前汇率：</span><span class="_3ZmEMAaXkrKqQ113p9F_uq">1 {{ payInfo.cardlist.content }} = {{ payInfo.info.usdtrate }} CNY</span>
            </div>
            <div class="_9SJLkU9QpzPYzWOZY3Rqk" v-if="type == 'usdtpay'">
              <span>充值数量：</span><span class="_3ZmEMAaXkrKqQ113p9F_uq">{{ payInfo.info.real_money }} {{ payInfo.cardlist.content }}</span>
            </div>
            <div class="_9SJLkU9QpzPYzWOZY3Rqk">
              <span>充值金额：</span><span class="_3ZmEMAaXkrKqQ113p9F_uq">{{ payInfo.info.amount }} CNY</span>
            </div>
          </div>
        </div>
        <div class="_2xx45NdpwT5KPaYgeMsdYE">
          <div class="_2q5dKVSXvbkX8syq1-Hl2W">
            <div class="_3VdBrxwboIJ2v_ON4OCRjS">{{ payInfo.info.paytype }}</div>
            <div class="_3785zJoWCXtLIHtAS_cA1C">
              <span>{{ payInfo.info.real_money }} {{ type == 'usdtpay' ? payInfo.cardlist.content : '' }}</span>
            </div>
            <div class="_1QI9TzXm1Ybnj9BJm4UQ7V">请注意：您的实际到账金额要与此金额完全一致，否则无法及时到账</div>
            <div class="_21R49Y-pIno9CckiAjl0Id">
              <div class="_1f6333Dfetv7YoltY9pL-t">{{ payInfo.cardlist.content }}</div>
              <div class="_2_w4FbHMpnRRSdxBYtSL0e">
                <img style="height: 210px; width: 210px" :src="payInfo.cardlist.payimg" alt="" />
              </div>
            </div>
            <div class="_3sbSiVFgNQ2SK94qDJaI90" v-if="type == 'usdtpay'">
              <span class="_2Vrrgjd_XLAifnNQgYu0NQ">{{ payInfo.cardlist.mch_id }}</span>
              <div class="f9bxdbnqcRudnKSP3y-bt" style="cursor: pointer" @click="doCopy(payInfo.cardlist.mch_id)">复制</div>
            </div>

            <!-- 新增：USDT支付时显示转账地址输入框 -->
            <div v-if="type == 'usdtpay'" class="transfer-address-container">
              <div class="transfer-label">哈希值（交易ID）：</div>
              <input
                type="text"
                v-model="transferAddress"
                placeholder="请输入您的哈希值（交易ID）"
                class="transfer-input"
              />
            </div>

          </div>
          <div class="_2eg9lTattt1yp1qvWhgifb">
            <div class="_2-xkzXq0hmbuW9CZeDhVx_">温馨提示</div>
            <div class="HU1qShwkRp6KtCq22dC6O" v-if="type != 'usdtpay'">
              1. 请勿向上述地址充值任何非<span class="M8ZjTEuW7Q3mUpU0PbEeW">{{ payInfo.cardlist.content }}</span
            >资产，否则资产将会丢失；<br />2. 请务必确认电脑及浏览器安全，防止信息被篡改或泄密。
              <br />
            </div>
            <div class="HU1qShwkRp6KtCq22dC6O" v-if="type == 'usdtpay'">
              1. 请勿向上述地址充值任何非<span class="M8ZjTEuW7Q3mUpU0PbEeW">{{ payInfo.cardlist.content }}</span
            >资产，否则资产将会丢失；<br />2. 向上述地址充值后，需要网络节点区块确认，链上网络确认后到账； <br />3. 请务必确认电脑及浏览器安全，防止信息被篡改或泄密。 <br />4. {{ type == 'usdtpay' ? payInfo.cardlist.content : 'TRC20' }}协议：请使用<span style="color: red">
                {{ type == 'usdtpay' ? (payInfo.info.bank == 'TRC20' ? '波场链' : '以太坊链') : '波场链' }}（{{ type == 'usdtpay' ? payInfo.info.bank : 'TRC20' }}协议） </span
            >进行交易 ，其他智能链充值造成的不到账，金额损失自己承担。
            </div>
          </div>

          <!-- 按钮区域：根据支付类型显示不同按钮 -->
          <div style="display: flex; align-items: center; justify-content: center; height: 30px; margin-top: 25px">
            <div v-if="type !== 'usdtpay'">
              <el-button type="success" @click="$router.push({ path: '/mine/transRecord' })">已完成付款</el-button>
            </div>
            <div v-else>
              <el-button type="success" @click="handleSubmit">提交转账信息</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: {},
      daoTime: null,
      m: 0,
      s: 0,
      type: null,
      transferAddress: '' // 新增：存储用户输入的转账地址
    };
  },
  components: {},
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.deposit_no) {
      that.getpayinfo(query.deposit_no);
    }
  },
  mounted() {
    this.countTime(); // 启动倒计时
  },
  methods: {
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.showTost('复制成功！');
    },
    getpayinfo(deposit_no) {
      let that = this;
      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.type = res.message;
        }
      });
    },
    countTime() {
      let that = this;
      var date = new Date();
      var now = date.getTime();
      let created_at = that.payInfo.info.created_at;
      let createdTime = new Date(created_at).getTime();
      var end = createdTime + 1000 * 60 * 60; // 1小时倒计时
      var leftTime = end - now;

      if (leftTime >= 0) {
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
      } else {
        that.m = 0;
        that.s = 0;
      }
      // 更新倒计时显示
      that.$forceUpdate();
      // 每秒更新一次
      setTimeout(this.countTime, 1000);
    },
    showTost(title) {
      // 移除之前的提示
      document.querySelectorAll('.ant-message').forEach(item => item.remove());
      // 创建新提示
      let messageDiv = document.createElement('div');
      messageDiv.className = 'ant-message';
      messageDiv.style.cssText = 'position: fixed; top: 20px; right: 20px; padding: 12px 24px; background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); z-index: 10000;';
      messageDiv.innerHTML = `
        <div class="ant-message-notice-content">
          <div class="ant-message-custom-content ant-message-info">
            <span class="anticon anticon-info-circle" style="margin-right: 8px;">
              <svg viewBox="64 64 896 896" focusable="false" data-icon="info-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path>
              </svg>
            </span>
            ${title}
          </div>
        </div>
      `;
      document.body.appendChild(messageDiv);
      setTimeout(() => messageDiv.remove(), 2000);
    },

    // 新增：提交转账地址逻辑
    handleSubmit() {
      // 1. 验证转账地址是否为空
      if (!this.transferAddress.trim()) {
        this.showTost('请输入哈希值（交易ID）');
        return;
      }

      // 2. （可选）添加USDT地址格式验证
      // const isUsdtAddressValid = /^0x[0-9a-fA-F]{40}$/.test(this.transferAddress); // ETH链地址格式示例
      // if (!isUsdtAddressValid) {
      //   this.showTost('请输入正确的USDT转账地址');
      //   return;
      // }

      // 3. 提交转账地址到服务器
      this.showTost('提交转账信息中...');
      this.$apiFun.post('/api/submitTransferAddress', {
        deposit_no: this.payInfo.deposit_no,
        transfer_address: this.transferAddress,
        pay_type: 'usdtpay'
      }).then(res => {
        if (res.code === 200) {
          this.showTost('转账信息提交成功，等待区块链确认');
          // 提交成功后跳转到交易记录页面
          setTimeout(() => {
            this.$router.push({ path: '/mine/transRecord' });
          }, 2000);
        } else {
          this.showTost('提交失败：' + res.message);
        }
      }).catch(err => {
        this.showTost('网络错误，请重试');
        console.error('提交转账地址失败：', err);
      });
    }
  },
  beforeDestroy() {
    // 清除倒计时定时器
    clearTimeout(this.countTime);
  }
};
</script>

<style lang="scss" scoped>
/* 新增：转账地址输入框样式，与原页面风格保持一致 */
.transfer-address-container {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .transfer-label {
    font-size: 14px;
    color: #333;
    margin-right: 10px;
  }
  .transfer-input {
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    font-size: 14px;
    width: 300px;
    &:focus {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
    }
  }
}

/* 调整原页面倒计时显示方式，使用Vue插值替代原生JS操作DOM */
._1ar3pTm_JYB-u2qWpt6e_z {
  display: inline-block;
  padding: 2px 8px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
}

/* 按钮样式调整，使提交按钮与原完成付款按钮保持一致 */
.el-button {
  padding: 8px 20px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/PayInfo.vue